<template>
  <header class="l-the-simple-header">
    <div class="p-the-simple-header">
      <div
        class="p-the-simple-header__header"
        :style="{ borderColor: colorCode }"
      >
        <div class="c-common-inner">
          <div class="p-the-simple-header__col">
            <a
              :href="isAdminSite ? '/dashboard/' : '/home/'"
              class="p-the-simple-header__logo"
              :style="serviceLogoStyle"
            >
              <img :src="serviceLogo" :alt="serviceName" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import commons from "@/common/store/modules/commons";
import AuthApi from "@/general/api/authApi";

@Options({ components: {} })
export default class TheSimpleHeader extends Vue {
  serviceLogoStyle: any = {};

  page_logo = "";

  get colorCode() {
    return commons?.colorCode;
  }

  get serviceName() {
    return commons?.serviceName;
  }

  get serviceLogo() {
    //#59042対応によりセッション情報からpage_logoを取得するように修正
    //return commons?.OrgPageSpecific?.page_logo;
    return this.page_logo;
  }

  // mounted() {
  //   this.initServiceLogoStyle();
  // }

  async created() {
    commons.setOrgPageSpecificDataFromLocalStorage();
    //#59042対応によりセッション情報からpage_logoを取得するように修正
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.page_logo = ic_session.pageLogo;
    })
    .catch(() => {
      this.page_logo = "";
    });
  }

  // initServiceLogoStyle() {
  // const { serviceLogo } = this;
  // const rem = 16;
  // const maxWidth = 3; // serviceLogo.width / rem;

  // this.serviceLogoStyle = {
  //   maxWidth: `${maxWidth}rem`,
  // };
  // }

  get isAdminSite() {
    return false;
  }
}
</script>

<style lang="scss" scoped>
.p-the-simple-header {
  background-color: $common-white;
  position: relative;
  z-index: 999;

  &__header {
    @include pc {
      min-width: rem($min-width--m);
    }
    @include sp {
      min-width: rem($min-width--s);
    }
    border-bottom: {
      width: px(3);
      style: solid;
    }
  }

  &__col {
    @include pc {
      padding: rem(16) 0;
    }
    @include sp {
      min-height: rem(48);
    }
    display: flex;
  }

  &__logo {
    @include pc {
      min-width: rem(280);
      max-width: rem(320);
      max-height: rem(48);
    }
    @include sp {
      width: 100%;
      max-height: rem(48);
    }
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    flex-grow: 1;

    img {
      @include sp {
        max-width: rem(140);
      }
      @include object-fit("contain");
      width: 100%;
      height: 100%;
      display: block;
      object-position: center;
    }
  }
}
</style>
